import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState} from "react";
import API from "../../../apiService";

const ModalChangeBatch = ({show, onHide, drug, detail, onSave, visit}) => {

  const [list, setList] = useState([])

  useEffect(() => {
    if (show && drug && detail) {
      getDrugs()
    }
  }, [show, drug, detail])

  const getDrugs = async () => {
    setList([])
    const res = await API.get(`drug/stock/read?keyword=${encodeURI(detail?.drug?.name)}&clinic_id=${visit.clinics.drug_clinic_id}`);
    if (res.code === 200) {
      setList(
        res.data
          .filter((dat) =>
            dat.user_approval_id !== null &&
            dat.stock_in.qty - dat.stock_out.qty > 0
          )
          .map(v => ({
            ...v,
            requested_qty: v.batch_number === detail?.drug_in_detail[0]?.batch_number ? detail?.qty|0 : 0,
            prescribe_id: v.batch_number === detail?.drug_in_detail[0]?.batch_number ? drug?.id : 0,
            prescribe_detail_id: v.batch_number === detail?.drug_in_detail[0]?.batch_number ? detail?.id : 0,
          }))
      )
    }
    else {
      console.error("Cannot load data from remote source");
    }
  }

  const save = () => {
    const requested_qty_exceeds = list.filter(v => v.requested_qty > v.stock_in.qty - v.stock_out.qty)
    if (requested_qty_exceeds.length) {
      const drug = requested_qty_exceeds[0]
      alert(`Jumlah diambil pada obat dengan no batch ${drug.batch_number} melebihi jumlah tersedia`)
      return
    }

    const requested_sum = list.map(v => v.requested_qty).reduce((a, b) => +a + +b, 0)
    if (requested_sum !== +(detail?.qty ?? 0)) {
      alert(`Jumlah diambil harus ${detail?.qty ?? 0}. Jumlah diambil sekarang adalah ${requested_sum}`)
      return
    }

    onSave(list.filter(v => +v.requested_qty).map(v => ({
      prescribe_id: v.prescribe_id,
      prescribe_detail_id: v.prescribe_detail_id,
      qty: v.requested_qty,
      available_qty: v.stock_in.qty - v.stock_out.qty,
      batch_number: v.batch_number,
      drug_in_detail_id: v.id,
      drug_id: v.drug_id,
      drug: v.drug,
    })))
  }

  return (
    <Modal
      show={ show }
      onHide={() => {
        setList([])
        onHide()
      }}
      size={'lg'}
      centered>
      <Modal.Body className={'pb-0'}>
        <h4 className={'mb-0'}>Ganti Batch</h4>
      </Modal.Body>
      <Modal.Body>
        <div className={'row'}>
          <div className={'col-12'}>
            <h5>OBAT: {detail?.drug?.name ?? ''}</h5>
            <h5>JUMLAH: {detail?.qty}</h5>
            <br/>
            <table className={'table table-bordered'}>
              <thead>
              <tr>
                <th>No</th>
                <th>No Batch</th>
                <th>Exp Date</th>
                <th>Jumlah Tersedia</th>
                <th>Jumlah Diambil</th>
              </tr>
              </thead>
              <tbody>
              {list.map((v, k) => (
                <tr key={`batch-${k}`} style={v.requested_qty > v.stock_in.qty - v.stock_out.qty ? {background: '#ffd6d6'} : {}}>
                  <td>{k + 1}</td>
                  <td>{v.batch_number}</td>
                  <td>{v.expired_date}</td>
                  <td>{v.stock_in.qty - v.stock_out.qty}</td>
                  <td>
                    <input type={'number'}
                           className={'form-control form-control-sm'}
                           onChange={e => {
                             let l = [...list]
                             l[k] = {...l[k], requested_qty: e.target.value}
                             setList(l)
                           }}
                           value={v.requested_qty}/>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className={'pt-0'}>
        <button type={'button'} className={'btn btn-success'} onClick={save}>
          Simpan
        </button>
        <button type={'button'} className={'btn btn-danger'} onClick={onHide}>
          Tutup
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalChangeBatch